<template>
  <div>
    <div class="container flash-message-top-container">
      <flash-message class="flash-message-top"></flash-message>
    </div>    
    <div class="container container-admin text-center">
      
      <h3>{{title}}</h3>
      <div class="form-group row">        
        <div class="col-md-6 label-left">
           <Language />  
        </div>
        </div>    
        <div class="form-group row">
          <div class="col-md-12 label-left">
            <label class="requered" for="title">Title</label>
            <input type="text" class="form-control" id="title" v-validate="'required'" name="title" aria-describedby="categoryTitle" placeholder="Category Title" v-model="category.title">    
            <span class="span-valid-text" v-show="errors.has('title')" >{{ errors.first('title') }} </span>
          </div>
        </div>
         <div class="form-group row">             
          <div class="col-md-12 label-left">
              <label for="txtCategoryDescription">Description</label>
              <HtmlEditor />    
          </div>
        </div>      
         <div class="form-group row">
          <div class="col-md-12 label-left">
            <label for="txtCategorySiteTitle">Site Title</label>
            <input type="text" class="form-control" id="txtCategorySiteTitle" aria-describedby="categorySiteTitle" placeholder="site title" v-model="category.site_title">    
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12 label-left">
            <label for="txtCategorySiteDescription">Site Description</label>
            <textarea class="form-control" id="txtCategorySiteDescription" style="resize: none;" rows="3" v-model="category.site_description"></textarea>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12 label-left">
            <label for="txtCategorySiteKeywords">Site Keywords</label>
            <textarea class="form-control" id="txtCategorySiteKeywords" style="resize: none;" rows="3" v-model="category.site_keywords"></textarea>  
          </div>
        </div>
        <button type="bottom" class="btn btn-primary" @click="(e) => saveCategory(e)">Save Category</button>
      </div>
    </div>
</template>

<script>

import HtmlEditor from "../../partial/HtmlEditor"
import Language from "../../partial/Language"
import { getDataFromServer } from "../../../utils/DataProvider";

  export default {
    data: () => {
      return{
         title: 'Category New',
         category: {title: '', description: '', image: '', language: '', site_title: '', site_description: '', site_keywords: ''}         
      }     
    },
    components: {
       HtmlEditor,
       Language,
    },
    methods: {
        changeLanguage(e){
          this.category.language = e.target.value
        },

        saveCategory(e){          
          this.$validator.validateAll().then((result) => {
            if(result){
              this.category.description = this.$store.getters.CATEGORY_DESCRIPTION;
              console.log("saveCategory: ", this.category);
              getDataFromServer('add_category', this.category)
              .then(data => 
              {
                console.log("response : ", data);
                this.flash('Saved category success', 'success', {timeout: 4000})
              })
              .catch(err => {
                console.log("response : ", err);
                this.flash('Saved category error: ' + err, 'error', {timeout: 4000})
              })             
            }
            else{
              this.flash('mandatory fields not filled ', 'error', {timeout: 4000})
            }
          })          
        },

        saveCategoryImageResponse(){

        }
    },
    created() {      
      var htmlEditorObj = {
        textAction: 'SET_CATEGORY_DESCRIPTION', 
        imageAction: 'SET_CATEGORY_IMAGES', 
        imageSaveCallBack: this.saveCategoryImageResponse, 
        text: 'category description',
        image: 'CATEGORY_IMAGES'}
      this.$store.dispatch('INIT_HTML_EDITOR', htmlEditorObj)

      //init language
      var languageObj = {
        name: 'language', 
        label: 'Language',
        selected: this.$store.getters.CURRENT_LANGUAGE,
        onSelectCB: this.changeLanguage, 
        }
      this.$store.dispatch('INIT_LANGUAGE_ENTITY', languageObj)
    }
  }
</script>

<style scoped>

</style>
